import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CatalogoRequest } from 'src/app/modal/catalogo/catalogo-request';
import { CatalogoResponse } from 'src/app/modal/catalogo/catalogo-response';
import { CarritoService } from 'src/app/service/carrito/carrito.service';
import { NovedadesService } from 'src/app/service/catalogo/novedades.service';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { UtilitarioService } from 'src/app/service/utilitarios/utilitario.service';
import { environment } from 'src/environments/environment';
import { ProtectedImageService } from 'src/app/service/catalogo/protected-image.service';
import { ProtectedImageResponse } from 'src/app/modal/catalogo/protected-image-response';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-portadas',
  templateUrl: './portadas.component.html',
  styleUrls: ['./portadas.component.scss']
})
export class PortadasComponent implements OnInit, OnDestroy {
  listFotografias:CatalogoResponse;
  flgAgregar:string = "0";

  // nlpr ini
  columnas = [[], [], []];
  isLoading: boolean = true; // Flag para mostrar skeletons de carga
  // nlpr fin

  protectedImages: Map<string, ProtectedImageResponse> = new Map();
  private imageUrlCache: Map<string, string | null> = new Map();
  private imageReadyForDisplay: Map<string, boolean> = new Map();
  public isSkeletonVisible: Map<string, boolean> = new Map();
  private navigationSubscription: Subscription;

  constructor(private novedadesService:NovedadesService,
    private usuarioService:UsuarioService,
    private carritoService:CarritoService,
    private router : Router,
    private utilitarioService:UtilitarioService,
    private protectedImageService: ProtectedImageService
    ) {
      // Escuchar cambios de navegación para limpiar cache
      this.navigationSubscription = this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          // console.log('Navegación detectada en portadas, limpiando cache de imágenes');
          this.clearProtectedImagesCache();
        });
    }

  buscarFotografias(){
    this.clearProtectedImagesCache(); // Limpiar cache antes de nueva búsqueda
    this.isLoading = true; // Activar flag de carga
    this.columnas = [[], [], []]; // Limpiar columnas

    let catalogoRequest:CatalogoRequest;
    catalogoRequest = new CatalogoRequest();
    this.listFotografias = new CatalogoResponse();
    catalogoRequest.authorId="0";
    catalogoRequest.categoryId="0";
    catalogoRequest.categoryName="PORTADAS_HISTORICAS";
    catalogoRequest.page="1";
    catalogoRequest.subCategoryId="0";
    catalogoRequest.subCategoryName="";
    catalogoRequest.publicationId="0";
    catalogoRequest.size="6";
    catalogoRequest.title="";
    catalogoRequest.yearId="0";

    this.novedadesService.buscarCatalogo(catalogoRequest).subscribe(data=>{
      // console.log("fotografia",data);
      if(data.response.codeResponse=="0000"){
        this.listFotografias = data;
        this.isLoading = false; // Desactivar flag de carga

        // nlpr ini
        this.listFotografias.response.list.forEach((fila, index) => {
          const columnaIndex = index % 3;  // Determina en qué columna irá el elemento
          this.columnas[columnaIndex].push(fila);
          // Cargar imagen protegida para cada elemento
          this.loadProtectedThumbnail(fila.activoId);
        });
        // nlpr fin
      }
    })
  }
  onComprar(id){
    if(this.usuarioService.obtenerSesionUsuario()){
      let idLibro = id;
      let cantidad = "1";
      let tipoProducto = "1";
      let sizeID ="0";
      let libroArray = {};
      cantidad = "1";
      this.carritoService.obtenerCantidadCarrito();    
      libroArray ={id:idLibro,cantidad:cantidad,tipoProducto:tipoProducto,sizeID:sizeID,modalidadId:1};
      //si agrega y limpio el carrito
      if((this.flgAgregar == "1") && ( this.carritoService.cantidadCarrito == 0)){
        this.carritoService.obtenerCantidadCarrito();
        this.carritoService.agregarCarrito(libroArray);
        this.router.navigate(['/procesarpago']);
        return;
      }
      //si no agrega, adiciona automaticamente al carrito
      if(this.flgAgregar == "0"){
        this.carritoService.obtenerCantidadCarrito();
        this.carritoService.agregarCarrito(libroArray);
        this.router.navigate(['/procesarpago']);
        return;
      }
      //si flag es 1 y no entra en las 2 condiciiones anteriores
      this.router.navigate(['/procesarpago']);
    }
    else{
      this.utilitarioService.toastrWarning("Necesita iniciar sesión");
    }
  }
  buscarConsulta(idCategoria,idSubCategoria){
    // console.log("idcate1:"+idCategoria);
    this.novedadesService.idCategoria=idCategoria;
    this.novedadesService.idSubCategoria=idSubCategoria;
    // console.log("idcate:"+this.novedadesService.idCategoria);
    // nlpr ini
    if (idCategoria==2){
      this.router.navigateByUrl('/portadas/'+this.generaNss());
    }else{
      this.router.navigateByUrl('/consultas/'+this.generaNss());
    }
    // nlpr fin
  }

  generaNss(){
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < charactersLength; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  /**
   * Genera un slug amigable desde el título
   */
  generateSlug(title: string): string {
    if (!title) return 'd';

    return title
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '') // Eliminar acentos
      .replace(/[^a-z0-9\s-]/g, '') // Eliminar caracteres especiales
      .trim()
      .replace(/\s+/g, '-') // Reemplazar espacios con guiones
      .replace(/-+/g, '-') // Reemplazar múltiples guiones con uno solo
      .substring(0, 100) || 'd'; // Limitar longitud y fallback
  }

  loadProtectedThumbnail(imageId: string): void {
    if (!imageId) {
      return;
    }

    // Evitar múltiples peticiones para la misma imagen
    if (this.protectedImages.has(imageId)) {
      return; // Ya está siendo procesada o ya existe
    }

    // console.log('🔄 Cargando imagen de inicio portadas:', imageId);

    // Marcar como en proceso para evitar duplicados
    this.protectedImages.set(imageId, {
      imageId: imageId,
      protectedThumbnailUrl: null,
      expiresIn: 0,
      loadedAt: Date.now()
    });

    this.protectedImageService.getProtectedThumbnail(imageId).subscribe({
      next: (response) => {
        response.loadedAt = Date.now();
        this.protectedImages.set(imageId, response);
        // Actualizar cache de URL
        this.imageUrlCache.set(imageId, response.protectedThumbnailUrl);

        // Esperar 800ms antes de ocultar skeleton
        setTimeout(() => {
          this.isSkeletonVisible.set(imageId, false);
          this.imageReadyForDisplay.set(imageId, true);
        }, 800);
      },
      error: (error) => {
        console.error('❌ Error cargando imagen de inicio portadas:', imageId, error);
        // Remover de la lista en caso de error para permitir reintento
        this.protectedImages.delete(imageId);
        this.isSkeletonVisible.delete(imageId);
      }
    });
  }

  // Cargar tokens de forma inteligente para elementos visibles
  loadTokensForCurrentPage(): void {
    if (!this.listFotografias?.response?.list) return;

    const currentPageItems = this.listFotografias.response.list;
    // console.log('Cargando tokens para', currentPageItems.length, 'portadas de la página actual');

    currentPageItems.forEach(item => {
      if (item.activoId) {
        this.loadProtectedThumbnail(item.activoId);
      }
    });
  }

  getProtectedImageUrl(imageId: string): string | null {
    if (!imageId) {
      return null;
    }

    // Si el skeleton está visible, no mostrar imagen aún
    if (this.isSkeletonVisible.get(imageId)) {
      return null;
    }

    // Si ya no está el skeleton, devolver la URL desde el cache
    return this.imageUrlCache.get(imageId) || null;
  }

  // Método público para el template - Siempre mostrar skeleton vertical hasta que la imagen esté lista
  shouldShowSkeleton(imageId: string): boolean {
    if (!imageId) return true; // Mostrar skeleton por defecto
    // Si no existe en el mapa, significa que aún no se ha cargado, mostrar skeleton
    if (!this.isSkeletonVisible.has(imageId)) {
      return true;
    }
    return this.isSkeletonVisible.get(imageId) || false;
  }

  clearProtectedImagesCache(): void {
    // console.log('Limpiando cache de imágenes protegidas para nueva carga');
    this.protectedImages.clear();
    this.imageUrlCache.clear();
    this.imageReadyForDisplay.clear();
    this.isSkeletonVisible.clear();
  }

  ngOnInit(): void {
    this.clearProtectedImagesCache(); // Limpiar cache al inicializar
    this.buscarFotografias();
  }

  ngOnDestroy(): void {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
    this.clearProtectedImagesCache();
  }

  ngAfterViewInit(): void {
    // Agregar event listeners para efecto holográfico después de que la vista se inicialice
    setTimeout(() => {
      this.addHolographicEffectListeners();
    }, 500);
  }

  addHolographicEffectListeners(): void {
    // Seleccionar CARDS completos (no solo contenedores de imagen)
    const cardsWeb = document.querySelectorAll('.panelFotografiaWeb');
    const cardsMovil = document.querySelectorAll('.panelFotografiaMovil');

    // Aplicar listeners a versión web (card completo)
    cardsWeb.forEach((card: HTMLElement) => {
      const imageContainer = card.querySelector('.imagen-container-holografico') as HTMLElement;
      const marcoContainer = card.querySelector('.marco-container') as HTMLElement;

      if (imageContainer) {
        this.applyHolographicListenersToCard(card, imageContainer, marcoContainer);
      }
    });

    // Aplicar listeners a versión móvil (card completo)
    cardsMovil.forEach((card: HTMLElement) => {
      const imageContainer = card.querySelector('.imagen-container-holografico') as HTMLElement;
      const marcoContainer = card.querySelector('.marco-container') as HTMLElement;

      if (imageContainer) {
        this.applyHolographicListenersToCard(card, imageContainer, marcoContainer);
      }
    });
  }

  private applyHolographicListenersToCard(card: HTMLElement, imageContainer: HTMLElement, marcoContainer: HTMLElement | null): void {
    // Función para manejar el movimiento del mouse sobre el CARD
    const handleMove = (e: MouseEvent | TouchEvent) => {
      let clientX: number, clientY: number;

      if (e instanceof MouseEvent) {
        clientX = e.clientX;
        clientY = e.clientY;
      } else if (e.touches && e.touches.length > 0) {
        clientX = e.touches[0].clientX;
        clientY = e.touches[0].clientY;
      } else {
        return;
      }

      // Obtener posición relativa al contenedor de imagen
      const rect = imageContainer.getBoundingClientRect();
      const x = ((clientX - rect.left) / rect.width) * 100;
      const y = ((clientY - rect.top) / rect.height) * 100;

      imageContainer.style.setProperty('--mouse-x', `${x}%`);
      imageContainer.style.setProperty('--mouse-y', `${y}%`);

      // Efecto 3D siguiendo el mouse (aplicado al marco completo)
      if (marcoContainer) {
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const mouseX = clientX - rect.left;
        const mouseY = clientY - rect.top;

        const rotateX = ((mouseY - centerY) / centerY) * -10;
        const rotateY = ((mouseX - centerX) / centerX) * 10;

        marcoContainer.classList.add('imagen-3d');
        marcoContainer.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      }
    };

    // Función para resetear efectos
    const handleEnd = () => {
      if (marcoContainer) {
        marcoContainer.classList.remove('imagen-3d');
        marcoContainer.style.transform = '';
      }
      imageContainer.style.setProperty('--mouse-x', '50%');
      imageContainer.style.setProperty('--mouse-y', '50%');
    };

    // Eventos de mouse en el CARD
    card.addEventListener('mousemove', handleMove as EventListener);
    card.addEventListener('mouseleave', handleEnd);

    // Eventos táctiles en el CARD
    let touchStartX = 0;
    let touchStartY = 0;
    let hasMoved = false;

    card.addEventListener('touchstart', (e: TouchEvent) => {
      hasMoved = false;
      if (e.touches.length > 0) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        imageContainer.classList.add('touch-active');
        handleMove(e);
      }
    }, { passive: true });

    card.addEventListener('touchmove', (e: TouchEvent) => {
      if (e.touches.length > 0) {
        const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
        const deltaY = Math.abs(e.touches[0].clientY - touchStartY);

        if (deltaX > 10 || deltaY > 10) {
          hasMoved = true;
          e.preventDefault();
          handleMove(e);
        }
      }
    });

    card.addEventListener('touchend', () => {
      imageContainer.classList.remove('touch-active');
      handleEnd();
      hasMoved = false;
    }, { passive: true });
  }

  private applyHolographicListeners(container: HTMLElement, marcoContainer: HTMLElement): void {
    let touchStartX = 0;
    let touchStartY = 0;
    let hasMoved = false;

    // Función común para manejar el movimiento (mouse o touch)
    const handleMove = (clientX: number, clientY: number) => {
      const rect = container.getBoundingClientRect();
      const x = ((clientX - rect.left) / rect.width) * 100;
      const y = ((clientY - rect.top) / rect.height) * 100;

      container.style.setProperty('--mouse-x', `${x}%`);
      container.style.setProperty('--mouse-y', `${y}%`);

      // Efecto 3D siguiendo el mouse/touch (aplicado al marco completo)
      if (marcoContainer) {
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const mouseX = clientX - rect.left;
        const mouseY = clientY - rect.top;

        const rotateX = ((mouseY - centerY) / centerY) * -10;
        const rotateY = ((mouseX - centerX) / centerX) * 10;

        marcoContainer.classList.add('imagen-3d');
        marcoContainer.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
      }
    };

    // Función común para resetear efectos
    const handleEnd = () => {
      if (marcoContainer) {
        marcoContainer.classList.remove('imagen-3d');
        marcoContainer.style.transform = '';
      }
      container.style.setProperty('--mouse-x', '50%');
      container.style.setProperty('--mouse-y', '50%');
    };

    // Eventos de mouse (desktop)
    container.addEventListener('mousemove', (e: MouseEvent) => {
      handleMove(e.clientX, e.clientY);
    });

    container.addEventListener('mouseleave', () => {
      handleEnd();
    });

    // Eventos táctiles (mobile)
    container.addEventListener('touchstart', (e: TouchEvent) => {
      hasMoved = false;
      if (e.touches.length > 0) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        // Activar brillo holográfico en mobile
        container.classList.add('touch-active');
        handleMove(e.touches[0].clientX, e.touches[0].clientY);
      }
    }, { passive: true });

    container.addEventListener('touchmove', (e: TouchEvent) => {
      if (e.touches.length > 0) {
        const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
        const deltaY = Math.abs(e.touches[0].clientY - touchStartY);

        // Solo marcar como movido si se movió más de 10px
        if (deltaX > 10 || deltaY > 10) {
          hasMoved = true;
          e.preventDefault(); // Prevenir scroll solo si realmente se está moviendo
          handleMove(e.touches[0].clientX, e.touches[0].clientY);
        }
      }
    });

    container.addEventListener('touchend', () => {
      // Desactivar brillo holográfico en mobile
      container.classList.remove('touch-active');
      handleEnd();
      // Reset flag
      hasMoved = false;
    }, { passive: true });
  }
}
